export type { Keypair, ProofProgress, ShieldedPoolId, RelayerPool, PoolSnapshot } from "./client";
export { clearProvingCache, prewarmProvingAssets } from "@/lib/shielded/assets";

type Client = typeof import("./client");
let cached: Promise<Client> | null = null;
const load = (): Promise<Client> => (cached ??= import("./client"));

type KeyVault = typeof import("./key-vault");
let keyVaultCached: Promise<KeyVault> | null = null;
const loadKeyVault = (): Promise<KeyVault> => (keyVaultCached ??= import("./key-vault"));
export const unlockOrCreateShieldedWallet = (...args: Parameters<KeyVault["unlockOrCreateShieldedWallet"]>) =>
  loadKeyVault().then((module) => module.unlockOrCreateShieldedWallet(...args));

export const fetchRelayerStatus: Client["fetchRelayerStatus"] = (...args) => load().then((m) => m.fetchRelayerStatus(...args));
export const waitForPoolIndex: Client["waitForPoolIndex"] = (...args) => load().then((m) => m.waitForPoolIndex(...args));
export const syncPool: Client["syncPool"] = (...args) => load().then((m) => m.syncPool(...args));
export const privateBalance = (...args: Parameters<Client["privateBalance"]>) => load().then((m) => m.privateBalance(...args));
export const buildPrivateShield: Client["buildPrivateShield"] = (...args) => load().then((m) => m.buildPrivateShield(...args));
export const buildPrivateTransfer: Client["buildPrivateTransfer"] = (...args) => load().then((m) => m.buildPrivateTransfer(...args));
export const buildPrivateUnshield: Client["buildPrivateUnshield"] = (...args) => load().then((m) => m.buildPrivateUnshield(...args));
export const submitPrivateViaRelayer: Client["submitPrivateViaRelayer"] = (...args) => load().then((m) => m.submitPrivateViaRelayer(...args));
export const toContractArgs = (...args: Parameters<Client["toContractArgs"]>) => load().then((m) => m.toContractArgs(...args));
